import { SCSS_COLORS } from "../../../colors";

export interface CircleButtonProps {
    color: string;
    backgroundColor: string;
    hover: {
        color: string;
        backgroundColor: string;
    }
}

export const BlueCircleButtonConfig = {
    color: SCSS_COLORS['$oe-blue'],
    backgroundColor: SCSS_COLORS['$oe-blue-medium'],
    hover: {
        color: SCSS_COLORS['$white'],
        backgroundColor: SCSS_COLORS['$oe-blue']
    }
}


// WEBPACK FOOTER //
// ./ts/app/components/circle-button/circle-button.props.ts